module.exports = __webpack_public_path__ + "media/images/countrysquared/sz-9ebc954f5d008dbe79ea11006da39d60.svg";